import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '@heidelberg/control-center-frontend-integration';
import { CCAuthService } from '@heidelberg/control-center-frontend-integration/auth';
import { HDMUIContactFormParams, HdmuiContactService, HDMUISendStatusType } from '@heidelberg/hdmui-angular';
import { Observable } from 'rxjs';

export function provideContactService(): HdmuiContactService {
    const http = inject(HttpClient);
    const configService = inject(ConfigService);
    const sessionService = inject(CCAuthService);

    return {
        send: (formData: HDMUIContactFormParams): Observable<HDMUISendStatusType> => {
            const personId = sessionService.getCurrentUser()?.id;
            const token = sessionService.getPersonToken();
            const url = `${configService.getControlCenterSvcUrl()}/persons/${personId}/contact`;
            const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
            return http.post<HDMUISendStatusType>(url, formData, { headers });
        },
    };
}
